import SearchResultsListItem from "../models/item.interface";
import fetchSearchItemsByRoute from "app/umbraco/helpers/fetchSearchItemsByRoute";

const fetchSearchResults = async (searchQuery: string) => {
    if(!searchQuery || searchQuery.trim() === "") return;

    if(searchQuery.length > 0) {
        const response: SearchResultsListItem = await fetchSearchItemsByRoute(window.location.origin, searchQuery);
        return response.items;
    }
};

export default fetchSearchResults;